export default __webpack_public_path__ + "static/media/38_Vyr_velky_upr_www.mezistromy.cz_thumb-min.06fae659.jpg";